import { render, staticRenderFns } from "./EditProfileAnchorLink.vue?vue&type=template&id=1950be88&scoped=true&"
import script from "./EditProfileAnchorLink.vue?vue&type=script&lang=js&"
export * from "./EditProfileAnchorLink.vue?vue&type=script&lang=js&"
import style0 from "./EditProfileAnchorLink.vue?vue&type=style&index=0&id=1950be88&prod&lang=scss&"
import style1 from "./EditProfileAnchorLink.vue?vue&type=style&index=1&id=1950be88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1950be88",
  null
  
)

export default component.exports